module.exports = __webpack_public_path__ + "images/header_about_mobile_1d4ef6031e35070d96a96f130ef2fe44.png";